import { ApolloCache } from '@apollo/client/cache';

export function removeObjectFromCache(cache: ApolloCache<any>, id: string, __typename: string) {
    cache.evict({
        id: cache.identify({ id, __typename }),
    });
    cache.gc();
}
